import React, { memo } from 'react'
import classNames from 'classnames'

import { Severity } from '../../../types'
import * as styles from './alert.module.scss'
import Svg from '../svg/svg'
import { AlertProps } from './types'

export const Alert = ({
   message,
   severity = Severity.ERROR,
   action,
}: AlertProps) => {
   const classes = classNames(styles.alert, {
      [styles[severity]]: true,
   })

   return (
      <div className={classes} role="alert">
         <div className={styles.icon}>
            <Svg id={severity} />
         </div>
         <div className={styles.message} aria-label={message}>
            <p>{message}</p>
         </div>
         {action && (
            <button type="button" className={styles.close} onClick={action}>
               <Svg id="close" />
            </button>
         )}
      </div>
   )
}

export default memo(Alert)
